export default function Marquee({ t }) {
  const items = [...t.marquee, ...t.marquee];
  return (
    <div data-testid="editorial-marquee" className="bg-pine py-6 md:py-8 overflow-hidden select-none" aria-hidden="true">
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {items.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-serif font-light italic text-ivory/80 text-2xl md:text-4xl px-6 md:px-10">
                  {item}
                </span>
                <span className="w-1.5 h-1.5 rounded-full bg-terracotta inline-block" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
